<template>
    <base-config-drawer ref="drawer" @click:delete-account="$emit('click:delete-account')">

        <v-list-item class="config-item" @click="$emit('click:edit', 'BasicInfo')">
            {{ $t('student.edit_basic_info') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:edit', 'SportRecord')">
            {{ $t('student.edit_sport_record') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:edit', 'PlaceTraining')">
            {{ $t('student.edit_places_training') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:edit', 'ChooseEquipments')">
            {{ $t('student.edit_implements') }}
        </v-list-item>

        <v-list-item class="config-item" @click="$emit('click:cancel-subscription')" v-if="showSubscriptionCancel">
            {{ $t('student.cancel_subscription') }}
        </v-list-item>

    </base-config-drawer>
</template>

<script>

import BaseConfigDrawer from '@/components/common/ConfigDrawer'

export default {
    components: { BaseConfigDrawer },
    props: {
        showSubscriptionCancel: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show() {
            this.$refs.drawer.show()
        },
        hide() {
            this.$refs.drawer.hide()
        },
    },
}

</script>
